/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_PendingInputs */

const en_us2_body_measures_pending = /** @type {(inputs: Body_Measures_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const pt_br2_body_measures_pending = /** @type {(inputs: Body_Measures_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const es_419_body_measures_pending = /** @type {(inputs: Body_Measures_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviando…`)
};

const pt_pt2_body_measures_pending = /** @type {(inputs: Body_Measures_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A enviar…`)
};

const fr_fr2_body_measures_pending = /** @type {(inputs: Body_Measures_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi…`)
};

const de_de2_body_measures_pending = /** @type {(inputs: Body_Measures_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird gesendet…`)
};

const it_it2_body_measures_pending = /** @type {(inputs: Body_Measures_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invio in corso…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Body_Measures_PendingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_pending = /** @type {((inputs?: Body_Measures_PendingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_PendingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_pending(inputs)
	if (locale === "es-419") return es_419_body_measures_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_pending(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_pending(inputs)
	if (locale === "de-DE") return de_de2_body_measures_pending(inputs)
	if (locale === "it-IT") return it_it2_body_measures_pending(inputs)
	return en_us2_body_measures_pending(inputs)
});
export { body_measures_pending as "body-measures.pending" }